<template>
  <div>
    <EXTooltip
        v-if="!myStuffTreeMode"
        placement="bottom"
        :description="tooltipDescription"
        :delay="500"
    >
      <div v-if="levelKey == 'novice'">
        <v-icon
        >
          $ex-chevron-right
        </v-icon>
      </div>
      <div v-else :class="['outer-square', levelKey]">
        <div class="inner-square">
          <div :class="['circle', badgeStatus]"></div>
        </div>
      </div>
    </EXTooltip>
    <div v-else>
      <div v-if="levelKey == 'novice'">
        <v-icon
        >
          $ex-chevron-right
        </v-icon>
      </div>
      <div v-else :class="['outer-square', levelKey]">
        <div class="inner-square">
          <div :class="['circle', badgeStatus]"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import EXTooltip from "@components/tooltip/EXTooltip.vue";
import { computed } from "vue";
import { isBadgeLevelValue, normalizeBadgeLevel } from "@components/utils/normalizeBadgeLevel";

const props = defineProps({
  badgeLevel: {
    type: String,
    default: 'apprentice',
    validator: (value) => isBadgeLevelValue(value)
  },
  badgeStatus: {
    type: String,
    default: 'forced',
    validator: (value) => ['forced', 'good_standing', 'obsolete', 'null'].includes(value)
  },
  myStuffTreeMode: {
    type: Boolean,
    default: false,
  },
});

const levelKey = computed(() => normalizeBadgeLevel(props.badgeLevel) || props.badgeLevel);

const tooltipDescription = computed(() => {
  if (levelKey.value == "novice") {
    return "Novice"
  } else if (!props.myStuffTreeMode) {
    const statusText = props.badgeStatus === 'forced' ? 'given' : props.badgeStatus;
    return `${levelKey.value.charAt(0).toUpperCase() + levelKey.value.slice(1)} ${formatStatus(statusText)}`
  }
});

const formatStatus = (text) => {
  if (text.includes('_')) {
    return text
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
  } else {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}
</script>

<style scoped>
.outer-square {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.outer-square.apprentice {
  background-color: #E58700;
}

.outer-square.proficient {
  background-color: #00B813;
}

.outer-square.coach {
  background-color: #00A3FF;
}

.outer-square.architect {
  background-color: #2E1EC1;
}

.inner-square {
  width: 12px;
  height: 12px;
  background-color: #FFEFEF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.circle.forced {
  background-color: #2C2C2C;
}

.circle.good_standing {
  background-color: #17B26A;
}

.circle.obsolete {
  background-color: #FF0303;
}

.circle.null {
  background-color: #CCCCCC;
}
</style>
